module.exports = __webpack_public_path__ + "img/pci.5c3fa13e.png";